import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3310f9ad&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Makes: require('/var/www/components/makes/makes.vue').default,MakesUpper: require('/var/www/components/makes/makes-upper.vue').default,CatalogListIndex: require('/var/www/components/catalog/catalog-list/catalog-list-index.vue').default,FeaturedBanks: require('/var/www/components/featured/featured-banks.vue').default,Services: require('/var/www/components/services/services.vue').default,FeaturedCarsPopular: require('/var/www/components/featured/featured-cars-popular.vue').default,Contacts: require('/var/www/components/contacts/contacts.vue').default,SeoTextHome: require('/var/www/components/seo-text/seo-text-home.vue').default})
